/**
 * Created by sswaminathan on 1/29/22
 * File: TestingDataIds
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */

export const DATA_TEST_CLAIM_LICENSE = 'claim-license-button'
export const DATA_TEST_COLUMN_SELECTION = 'claim-column-selection-button'
export const DATA_TEST_UN_CLAIM_LICENSE = 'unclaim-license-button'
export const DATA_TEST_TENANT_SELECTION_TSG = 'tenant-selection-tsg'
export const DATA_TEST_TENANT_SELECTION_CSP = 'tenant-selection-csp'
export const DATA_TEST_EULA = 'subscription_eula'
export const DATA_ALLOCATION_SUBMIT = 'subscription-allocation'
export const DATA_CONTRACT_DROPDOWN = 'subscription-contract-dropdown'
export const DATA_REGION_DROPDOWN = 'subscription-region-dropdown'
